// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/routes/advisor/routes/University/routes/University/components/University/styles.scss
// module id = 738
// module chunks = 0